import type {
  ACSIncomingMessages,
  CONFIGURE,
  Core,
  Subscription,
  LoginOptions,
} from "@mos-utils/acs-core";

import { getCircuitPath } from "./url";

declare global {
  interface Window {
    core0521: Core;
  }
}

declare let __DEV__: boolean;

/**
 * @internal
 */
export class ACS {
  private history: ACSIncomingMessages[] = [];
  private ready = false;

  constructor() {
    if (typeof window === "undefined") {
      return;
    }
    this.run();
  }

  private run() {
    if (!window.core0521) {
      this.init_script();
      return;
    }
    this.ready = true;
    if (this.history.length > 0) this.send(this.history);
  }
  private init_script() {
    let script = document.querySelector<HTMLScriptElement>(
      'script[src*="core0521.js"], script[src*="core0521.dev.js"]'
    );
    if (script === null) {
      script = document.createElement("script");
      script.src = __DEV__
        ? getCircuitPath("/shared/acs/core0521.dev.js")
        : getCircuitPath("/shared/acs/core0521.js");
      script.async = true;
      document.body.appendChild(script);
    }
    script.addEventListener("load", this.run.bind(this));
  }

  send(message: ACSIncomingMessages | ACSIncomingMessages[]) {
    if (!this.ready) {
      this.history = this.history.concat(message);
    } else {
      window.core0521.send(message);
    }
  }
  subscribe(subscription: Subscription) {
    this.send({ type: "SUBSCRIBE", subscription });
    return () => this.unsubscribe(subscription);
  }
  unsubscribe(subscription: Subscription) {
    this.send({ type: "UNSUBSCRIBE", subscription });
  }
  login(backURL?: string, options?: LoginOptions) {
    this.send({ type: "LOGIN", backURL, options });
  }
  logout(backURL?: string) {
    this.send({ type: "LOGOUT", backURL });
  }
  register(backURL?: string) {
    this.send({ type: "REGISTER", backURL });
  }
  refetchProfile() {
    this.send({ type: "FETCH_PROFILE" });
  }
  refreshToken() {
    this.send({ type: "REFRESH_TOKEN" });
  }
  refetchRoles() {
    this.send({ type: "FETCH_ROLES" });
  }
  switchRole(id: string) {
    this.send({ type: "SWITCH_ROLE", id });
  }
  resetRole() {
    this.send({ type: "SWITCH_ROLE" });
  }
  configure({
    backUrl: backURL,
  }: {
    backUrl: CONFIGURE["options"]["backURL"];
  }) {
    this.send({ type: "CONFIGURE", options: { backURL } });
  }
}

/**
 * @public
 */
export default new ACS();
